// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"O--z","dimensionLabel":"P--z","styleChooserControlWrapper":"Q--z","styleChooserControl":"R--z","disabled":"S--z","giftCard":"T--z","styleChooserText":"U--z"};